const NotFound = () => {
  return (
    <div className="min-h-screen bg-yellow-50 flex items-center justify-center">
      {/* Container div with minimum height of the screen, yellow background, and flexbox centering */}
      <h1 className="text-4xl font-bold text-yellow-700">404 - Not Found!</h1>
      {/* Heading with large text, bold font, and yellow color */}
    </div>
  );
};

export default NotFound;
